import { Asset } from '../..';
import { equitySellOffersQueryUpdated } from '../../../../../../../../store/product/selectors';
import { ListLoadingItem } from '../Equity/ListLoadingItem';

import { EquityListItem } from './ListItem';

export const EquitySellAsset = () => {
  return (
    <Asset
      productsQuery={equitySellOffersQueryUpdated}
      ProductItem={EquityListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
